<div class="layout-container">
  <!-- Header -->
  <app-header></app-header>
  
  <!-- Main Content Area -->
  <div class="main-container">
    <!-- Sidebar -->
    <app-sidebar></app-sidebar>
    
    <!-- Content Area -->
    <main class="content-area">
      <router-outlet></router-outlet>
    </main>
  </div>
  
  <!-- Footer -->
  <footer class="layout-footer">
    <p>&copy; <a href="https://powerserve.global/" target="_blank" rel="noopener noreferrer" class="copyright-link">PowerServe Systems Ltd</a>. {{ currentYear }}. All rights reserved.</p>
  </footer>
</div>
